var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    fill: "none",
    viewBox: "0 0 19 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0875C4",
    fillRule: "evenodd",
    d: "M2.167 5.833a2.5 2.5 0 0 1 2.5-2.5h11.666a2.5 2.5 0 0 1 2.5 2.5v8.334a2.5 2.5 0 0 1-2.5 2.5H4.667a2.5 2.5 0 0 1-2.5-2.5zM4.667 5a.833.833 0 0 0-.834.833v8.334c0 .46.373.833.834.833h11.666c.46 0 .834-.373.834-.833V5.833A.833.833 0 0 0 16.333 5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0875C4",
    fillRule: "evenodd",
    d: "M3.244 4.41a.833.833 0 0 1 1.179 0l6.077 6.078 6.077-6.077a.833.833 0 1 1 1.179 1.178l-6.078 6.078c-.65.65-1.706.65-2.357 0L3.244 5.589a.833.833 0 0 1 0-1.178",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0875C4",
    fillRule: "evenodd",
    d: "M8.59 9.41a.833.833 0 0 1 0 1.18l-4.167 4.166a.833.833 0 0 1-1.179-1.178L7.411 9.41a.833.833 0 0 1 1.178 0M12.41 9.41a.833.833 0 0 0 0 1.18l4.167 4.166a.833.833 0 0 0 1.179-1.178L13.589 9.41a.833.833 0 0 0-1.178 0",
    clipRule: "evenodd"
  })));
};
export { SvgEnvelope as Icon };
export default __webpack_public_path__ + "static/media/975bfe9dbfde251a598cd67e3a8f21cf.svg";